
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/account/billing",
      function () {
        return require("private-next-pages/docs/account/billing.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/account/billing"])
      });
    }
  